<div *ngIf="buttonView">
  <p-selectButton
    [options]="dataSource | lxSortBy : sortCriteria"
    [ngModel]="selectedValue"
    optionLabel="name"
    optionValue="code"
    styleClass="language__selector"
    (onChange)="languageSelected($event)"
    [attr.data-qa]="'language-selector'"
  ></p-selectButton>
</div>

<lx-form-field-selector
  *ngIf="!buttonView"
  [label]="label"
  [disabled]="disabled"
  [value]="value"
  valueExpr="code"
  [itemList]="dataSource"
  [buttonView]="false"
  [placeholder]="placeholder"
  [required]="required"
  [sortCriteria]="sortCriteria"
  [iconValidation]="true"
  (valueChange)="valueChange.emit($any($event))"
></lx-form-field-selector>
